

<template>
  <div class="dashboard">
     <SettingsComp />
  </div>
</template>

<script >
import SettingsComp from '@/components/SettingsComp.vue'

export default{
  components: {
    SettingsComp
  }
}
</script>